import { Component, OnInit, Inject } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { Router } from '@angular/router';
import * as wjInput from '@grapecity/wijmo.input';

import { WijmoUtils } from './shared/utils/wijmo-utils.service';
import { NgbModalConfig, NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { faCalendarAlt } from '@fortawesome/free-regular-svg-icons';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})

export class AppComponent implements OnInit {

  faCalendarIcon = faCalendarAlt;

  /**
   * Creates an instance of AppComponent.
   * @param {string} baseHref ベースURL
   * @param {Router} router ルーター
   * @memberof AppComponent
   */
  constructor(
    @Inject(APP_BASE_HREF) private baseHref: string,
    private router: Router,
    private ngbModalConfig: NgbModalConfig,
    private ngbTootipConfig: NgbTooltipConfig,
  ) { 
    ngbModalConfig.animation = false; // 2023.12.11 shuto add（アニメーションさせたくなったら外してください）
    ngbTootipConfig.container = 'body';
  }

  /**
   * 初期処理
   *
   * @memberof AppComponent
   */
  ngOnInit(): void {

    // this.router.navigate(['/test']);

    // Wijmoのライセンスを設定
    WijmoUtils.setLicenseKey();

    // ベースURLを除いたパスを取得
    let path = window.location.pathname;
    let baseUrl = this.baseHref;
    if (baseUrl.substr(-1) === '/') {
      baseUrl = baseUrl.substr(0, baseUrl.length - 1);
    }

    path = path.replace(baseUrl, '');

    // printの場合以外は、認証検証画面へ遷移させる
    if (path.indexOf('/print') !== 0 && path.indexOf('/kymw') !== 0 && path.indexOf('/subwindow') !== 0
      && path.indexOf('/login') !== 0 && path.indexOf('/auth') !== 0 && path.indexOf('/employee') !== 0
      && path.indexOf('/partner') !== 0 && path.indexOf('/N_PEACE/file/') !== 0 ) {
      this.router.navigate(['/auth']);
    }
    
    // 日付コントロールのテンプレート設定
    wjInput.InputDate.controlTemplate =
      '<div style="position:relative" class="wj-template">'
      + '<div class="wj-input">'
      + '<div class="wj-input-group wj-input-btn-visible">'
      + '<input wj-part="input" type="text" class="wj-form-control" disabled />'
      + '<span wj-part="btn" class="wj-input-group-btn" tabindex="-1">'
      + '<button class="wj-btn wj-btn-default" type="button" tabindex="-1">'
      + '<fa-icon class="ng-fa-icon">'
      + '<svg class="calendar-icon-style" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + this.faCalendarIcon.icon[0] + ' ' + this.faCalendarIcon.icon[1] + '">' // width,height指定
      + '<path d="' + this.faCalendarIcon.icon[4] + '"/>'
      + '</svg>'
      + '</fa-icon>'
      + '</button>'
      + '</span>'
      + '</div>'
      + '</div>'
      + '<div wj-part="dropdown" class="wj-content wj-dropdown-panel" '
      + 'style="display:none;position:absolute;z-index:100">'
      + '</div>'
      + '</div>';

    // 数値入力コントロール
    wjInput.InputNumber.controlTemplate =
      '<div style="position:relative" class="wj-template">'
      + '<div class="wj-input">'
      + '<div class="wj-input-group wj-input-btn-visible">'
      + '<input wj-part="input" type="tel" class="wj-form-control wj-numeric" />'
      + '<span wj-part="btn-dec" class="wj-input-group-btn down-button" tabindex="-1">'
      + '<button class="wj-btn wj-btn-default" type="button" tabindex="-1">▼</button>'
      + '</span>'
      + '<span wj-part="btn-inc" class="wj-input-group-btn up-button" tabindex="-1">'
      + '<button class="wj-btn wj-btn-default" type="button" tabindex="-1">▲</button>'
      + '</span>'
      + '</div>'
      + '</div>';

    // F5キーを無効化
    window.addEventListener('keydown', (event: KeyboardEvent) => {
      if (event.key === 'F5') {  // F5の場合はイベントキャンセル
        event.preventDefault();
      }
    });
  }
}
